const path = {
  HOME: "/",
  SIGN_IN: "/sign-in",
  USER: "/user",
  USER_MANAGER: "/user-manage",
  ROLE: "/role",
  ROLE_MANAGER: "/role-manage",
  ACOOUNT_MANAGER: "/account-manage",
  USER_CREATE: "/user-create",
  ADD_ACCOUNT: "/add-account",
  STATISTICAL: "/statistical",
  STATISTICAL_MANAGE: "/statistical-manage",
  ACCOUNT: "/account",
  ACCOUNT_UPDATE_INFO: "/account-update-info",
  ACCOUNT_UPDATE_PASSWORD: "/account-update-password",
  STORE: "/store",
  STORE_MANAGE: "/store-manage",
  STORE_ADD_ACCOUNT: "/store-add-account",
  MY_STORE: "/my-store",
  MACHINE: "/machine",
  MACHINE_MANAGE: "/machine-manage",
  MACHINE_OF_STORE: "/machine-of-store-manage",
  MACHINE_USER_MANAGE: "/machine-user-manage",
  REVENUE_MACHINE_OVERALL: "/revenue-machine-overall",
  REVENUE: "/revenue",
  REVENUE_STORE: "/revenue-store",
  REVENUE_MACHINE: "/revenue-machine",
  REVENUE_STORE_USER: "/revenue-store-user",
  REVENUE_MACHINE_USER: "/revenue-machine-user",
  TRACKING: "/tracking",
  TYPE_TRANSACTION: "/type-transaction",
  SOLUTION: "/solution",
  RESULT: "/result",
  DETAIL_ERROR: "/detail-error",
  VOUCHER: "/voucher",
  VOUCHER_MANAGE: "/voucher-manage",
  FRAME_MANAGE: "/frame-manage",
  FRAME: "/frame",
  FRAME_ANALYSTIC: "/frame-analystic",
  VERIFY_NEW_ACCOUNT: "/verify-new-account",
  TRANSACTION: "/transaction",
  TRANSACTION_MANAGE: "/transaction-manage",
};

export default path;
